/*LIBRARY*/
import { useRef, useEffect, useCallback, useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import SIDEBAR_CONTENT from "./SIDEBAR_CONTENT";
import SIDEBAR_MINI from "./SIDEBAR_MINI";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import { set_value_layer } from "../../App/actions/layerActions";
import { set_value_insight } from "../../App/actions/insight_v2";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/
const min_height = 185;
const max_height = window.innerHeight * 0.97;
const mobile_width = 767;
const sidebar_closed = 70;

const SIDEBAR_CONTAINER = ({
  layer,
  properties,
  set_value_properties,
  set_value_layer,
  set_value_insight,
}) => {
  const activate_bar = () => {
    // Add a small delay to ensure drag operations have finished
    setTimeout(() => {
      set_value_properties({
        key: "sidebar_right_status",
        value: true,
      });
      set_value_properties({
        key: "is_mobile_close",
        value: false,
      });
      set_value_properties({
        key: "sidebar_height",
        value: 500,
      });
    }, 10); // Small delay to prevent race conditions
  };

  const {
    sidebar_right_status,
    sidebar_height,
    is_mobile,
    is_dragging,
    is_mobile_close,
  } = properties;
  const { geo_layer_list, layer_id } = layer;

  const [is_transitioning_open, set_is_transitioning_open] = useState(false);
  const prev_layer_id_ref = useRef();
  const drag_timeout_ref = useRef(null); // Add ref to track drag timeout

  useEffect(() => {
    const prev_layer_id = prev_layer_id_ref.current;
    prev_layer_id_ref.current = layer_id;
    if (!!layer_id && prev_layer_id !== layer_id) {
      const geo_layer = geo_layer_list.find(
        (item) => item?.geo_layer?._id === layer_id
      )?.geo_layer;
      const ss_version = geo_layer?.insight_object?.version;
      if (ss_version === 3) {
        set_value_properties({
          key: "legend_status",
          value: false,
        });
        set_value_layer({
          key: "statistic_mode",
          value: "sini",
        });
        set_value_insight({
          key: "site_selection_view",
          value: "report",
        });
        //set insight object ke reducer
        const strings = [
          "array_formula_insight",
          "array_group_insight",
          "config_final_score",
          "provinsi",
          "kota",
          "kecamatan",
          "kelurahan",
          "tipe_1_array",
          "tipe_2_array",
          "tipe_3_array",
          "tipe_level",
          "tipe_1_all",
          "total_poi_initial",
          "grid_mode",
          "grid_counts",
          "grid_width_meters",
          "total_square_meters",
        ];
        strings.forEach((item) => {
          set_value_insight({
            key: item,
            value: geo_layer?.insight_object?.[item],
          });
        });
      } else {
        set_value_layer({
          key: "statistic_mode",
          value: "data",
        });
        set_value_insight({
          key: "site_selection_view",
          value: "input",
        });
      }
    }
  });

  const set_sidebar_height = useCallback(
    (value) => {
      if (is_mobile_close) {
        set_is_transitioning_open(true);
        set_value_properties({ key: "sidebar_height", value: 500 });
        setTimeout(() => {
          set_value_properties({ key: "is_mobile_close", value: false });
          set_is_transitioning_open(false);
        }, 300);
      } else {
        set_value_properties({ key: "sidebar_height", value });
        if (value < min_height + 10) {
          set_value_properties({
            key: "sidebar_height",
            value: sidebar_closed,
          });
          set_value_properties({ key: "is_mobile_close", value: true });
        }
      }
    },
    [set_value_properties, is_mobile_close]
  );

  const set_is_mobile = useCallback(
    (value) => {
      set_value_properties({ key: "is_mobile", value });

      if (value === false) {
        set_value_properties({
          key: "is_mobile_close",
          value: false,
        });
        set_value_properties({
          key: "is_transitioning_open",
          value: false,
        });
        set_value_properties({
          key: "sidebar_height",
          value: "pc",
        });
      }
    },
    [set_value_properties]
  );

  const set_is_dragging = useCallback(
    (value) => {
      set_value_properties({ key: "is_dragging", value });
    },
    [set_value_properties]
  );

  const drag_info_ref = useRef({
    initial_y: 0,
    initial_height: 0,
    last_y: 0,
    last_time: 0,
  });

  const handle_mouse_down = (e) => {
    e.preventDefault();
    set_is_dragging(true);
    drag_info_ref.current = {
      initial_y: e.clientY,
      initial_height: sidebar_height,
      last_y: e.clientY,
      last_time: Date.now(),
    };
    window.addEventListener("mousemove", handle_mouse_move);
    window.addEventListener("mouseup", handle_mouse_up);
  };

  const handle_mouse_up = () => {
    set_is_dragging(false);
    window.removeEventListener("mousemove", handle_mouse_move);
    window.removeEventListener("mouseup", handle_mouse_up);
  };

  const handle_touch_start = (e) => {
    set_is_dragging(true);
    drag_info_ref.current = {
      initial_y: e.touches[0].clientY,
      initial_height: sidebar_height,
      last_y: e.touches[0].clientY,
      last_time: Date.now(),
    };
    window.addEventListener("touchmove", handle_touch_move, { passive: false });
    window.addEventListener("touchend", handle_touch_end);
  };

  const handle_touch_end = () => {
    set_is_dragging(false);
    window.removeEventListener("touchmove", handle_touch_move);
    window.removeEventListener("touchend", handle_touch_end);
  };

  const apply_drag_height = (new_height, velocity = 0) => {
    if (new_height >= min_height && new_height <= max_height) {
      set_sidebar_height(new_height);
    }
    if (
      (velocity > 0.3 && new_height < min_height + 60) ||
      new_height < min_height + 10
    ) {
      // Clear any existing timeout
      if (drag_timeout_ref.current) {
        clearTimeout(drag_timeout_ref.current);
      }

      // Add a small delay before closing to prevent race conditions
      drag_timeout_ref.current = setTimeout(() => {
        set_value_properties({ key: "is_mobile_close", value: true });
        set_value_properties({ key: "sidebar_height", value: sidebar_closed });
      }, 50);
    }
  };

  const handle_mouse_move = (e) => {
    const deltaY = e.clientY - drag_info_ref.current.initial_y;
    const new_height = drag_info_ref.current.initial_height - deltaY;

    apply_drag_height(new_height);
  };

  const handle_touch_move = (e) => {
    e.preventDefault();
    const current_y = e.touches[0].clientY;
    const deltaY = current_y - drag_info_ref.current.initial_y;
    const new_height = drag_info_ref.current.initial_height - deltaY;

    const now = Date.now();
    const time_diff = now - drag_info_ref.current.last_time;
    const y_diff = current_y - drag_info_ref.current.last_y;
    const velocity = y_diff / time_diff;

    drag_info_ref.current.last_y = current_y;
    drag_info_ref.current.last_time = now;

    apply_drag_height(new_height, velocity);
  };

  useEffect(() => {
    const handle_resize = () => {
      set_is_mobile(window.innerWidth <= mobile_width);
    };
    window.addEventListener("resize", handle_resize);
    return () => {
      window.removeEventListener("resize", handle_resize);
      // Clean up timeout on unmount
      if (drag_timeout_ref.current) {
        clearTimeout(drag_timeout_ref.current);
      }
    };
  }, [set_is_mobile]);

  let right = "39px";
  if (!sidebar_right_status) {
    right = "-352px";
  }

  const pc_sidebar = (
    <div
      style={{
        position: "fixed",
        top: "5px",
        bottom: "37px",
        right: right,
        width: "313px",
        maxWidth: "100vw",
        borderRadius: "9px 9px 9px 9px",
        overflow: "hidden",
        backgroundColor: "white",
        boxShadow: "0 0 10px 5px rgba(0, 0, 0, 0.15)",
        boxSizing: "border-box",
        transition: "right 0.4s cubic-bezier(0.4, 0.0, 0.2, 1)",
      }}
    >
      <SIDEBAR_CONTENT />
    </div>
  );

  const mobile_sidebar = (
    <div
      style={{
        zIndex: 3,
        position: "fixed",
        bottom: "0",
        left: "0",
        backgroundColor: "rgba(255, 255, 255, 1)",
        width: "100vw",
        height: `${sidebar_height}px`,
        borderRadius: "15px 15px 0 0",
        boxSizing: "border-box",
        overflow: "hidden",
        boxShadow: "0 0 10px 5px rgba(0, 0, 0, 0.15)",
        display: "flex",
        flexDirection: "column",
        transition: is_dragging ? "none" : "all 0.3s ease-in-out",
        touchAction: "none",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "row-resize",
          flexShrink: 0,
        }}
        onMouseDown={handle_mouse_down}
        onTouchStart={handle_touch_start}
      >
        <button
          style={{
            width: is_dragging ? "111px" : "35px",
            height: is_dragging ? "17px" : "5px",
            backgroundColor: is_dragging ? "#000" : "#ccc",
            borderRadius: "2em",
            transition: "background-color 0.2s ease-in-out",
          }}
        />
      </div>
      <div
        style={{
          flexGrow: 1,
          overflowY: "hidden",
          paddingRight: "15px",
          paddingLeft: "15px",
        }}
      >
        <SIDEBAR_CONTENT />
      </div>
    </div>
  );

  const mobile_sidebar_closed = (
    <div
      style={{
        zIndex: 3,
        position: "fixed",
        bottom: "65px",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)",
        width: "229px",
        height: "90px",
        borderRadius: "45px",
        boxSizing: "border-box",
        overflow: "hidden",
        boxShadow: "0 4px 31px 0 rgba(0, 0, 0, 0.5)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        transition:
          "height 0.3s ease-in-out, background-color 0.2s ease-in-out",
        border: "1px solid rgba(255, 255, 255, 0.2)",
      }}
      onClick={activate_bar}
    >
      <SIDEBAR_MINI />
    </div>
  );

  let final_content;

  if (is_mobile_close || is_transitioning_open) {
    final_content = mobile_sidebar_closed;
  } else if (is_mobile) {
    final_content = mobile_sidebar;
  } else {
    final_content = pc_sidebar;
  }

  return <main>{final_content}</main>;
};

const map_state_to_props = (state) => ({
  layer: state.layer,
  properties: state.properties,
});

export default connect(map_state_to_props, {
  set_value_properties,
  set_value_layer,
  set_value_insight,
})(SIDEBAR_CONTAINER);
